import PropTypes from 'prop-types';
import React from 'react';
import Tippy from '@tippyjs/react';

const columnContainerStyle = {
  width: '320px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  padding: '0 20px',
  alignSelf: 'stretch'
};

const titleStyle = {
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '20px',
  color: 'var(--od-c-333333, #333333)'
};

const metricsRowStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  alignSelf: 'stretch',
  justifyContent: 'flex-end'
};

const metricGroupStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end'
};

const metricLabelStyle = {
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '18px',
  color: 'var(--od-c-535862, #535862)'
};

const metricValueStyle = {
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '20px',
  color: 'var(--od-c-333333, #333333)'
};

const metricValueNegativeStyle = {
  ...metricValueStyle,
  color: '#d92d20'
};

const MetricColumn = ({
  active,
  title,
  artistEarningsLabel,
  artistEarningsValue,
  venueNetLabel,
  venueNetTooltip,
  venueNetValue,
  showBorderRight,
  formatCalculatedNumber
}) => {
  if (!active) return null;

  const containerStyle = showBorderRight
    ? { ...columnContainerStyle, borderRight: '1px solid var(--od-c-e9eaeb, #E9EAEB)' }
    : columnContainerStyle;

  const venueNetStyle = (venueNetValue || 0) >= 0 ? metricValueStyle : metricValueNegativeStyle;

  return (
    <div style={containerStyle}>
      <span style={titleStyle}>{title}</span>
      <div style={metricsRowStyle}>
        <div style={metricGroupStyle}>
          <span style={metricLabelStyle}>{artistEarningsLabel}</span>
          <span style={metricValueStyle}>{formatCalculatedNumber(artistEarningsValue)}</span>
        </div>
        <div style={metricGroupStyle}>
          <span style={metricLabelStyle}>
            {venueNetLabel}
            {venueNetTooltip && (
              <Tippy
                content={venueNetTooltip}
                placement="top"
                animation="shift-away"
                theme="material"
              >
                <a href="#" className="text-muted ml-2" onClick={(e) => e.preventDefault()}>
                  <i className="fas fa-info-circle"></i>
                </a>
              </Tippy>
            )}
          </span>
          <span style={venueNetStyle}>{formatCalculatedNumber(venueNetValue)}</span>
        </div>
      </div>
    </div>
  );
};

MetricColumn.propTypes = {
  active: PropTypes.bool,
  title: PropTypes.string.isRequired,
  artistEarningsLabel: PropTypes.string.isRequired,
  artistEarningsValue: PropTypes.number,
  venueNetLabel: PropTypes.string.isRequired,
  venueNetTooltip: PropTypes.string,
  venueNetValue: PropTypes.number,
  showBorderRight: PropTypes.bool,
  formatCalculatedNumber: PropTypes.func.isRequired
};

export default MetricColumn;
